const pathToContent = (content) => (
  content?.language_iso_code
    ? `/${content.language_iso_code.toLowerCase()}${content.route}`
    : (content?.route || content?.url)
);

export default pathToContent
